import { render, staticRenderFns } from "./CryptoDress.vue?vue&type=template&id=045fe848"
import script from "./CryptoDress.vue?vue&type=script&lang=js"
export * from "./CryptoDress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports